import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dispatch-board-loader',
  templateUrl: './dispatch-board-loader.component.html',
  styleUrl: './dispatch-board-loader.component.scss'
})
export class DispatchBoardLoaderComponent {
@Input('isLoading') isLoading: boolean = false;
constructor() {

  
}
}
